import React from 'react'

//  Default Component to show when loading auth page.
const LoadingAuthPage = () => {
  return <div>Taking you to auth page...</div>
}

export default LoadingAuthPage
